import React, { Component } from "react";

class CodigoGeografico extends Component {
    constructor(props) {
        super(props);

        const { GET_CODIGO_GEOGRAFICO } = props.data.cuentaDatos.accountData;

        this.state = {
            valorCodGeograficoInput: "",
            existeAlMenosUnCodGeo: GET_CODIGO_GEOGRAFICO.some(cg => cg.CodigoGeografico == props.valorCodGeografico)
        }

        if (this.state.existeAlMenosUnCodGeo == false) {
            this.state.valorCodGeograficoInput = props.valorCodGeografico;
        }

        this.actualizarValorInput = this.actualizarValorInput.bind(this);
    }
    /**
     * 
     * @param {any} valor
     */
    actualizarValorInput(valor, callback) {
        this.setState({ valorCodGeograficoInput: valor }, callback);
    }

    componentWillReceiveProps(nextProps) {
        const { GET_CODIGO_GEOGRAFICO } = nextProps.data.cuentaDatos.accountData;

        this.state.existeAlMenosUnCodGeo = GET_CODIGO_GEOGRAFICO.some(cg => cg.CodigoGeografico == nextProps.valorCodGeografico);

        if (this.state.existeAlMenosUnCodGeo) {
            this.state.valorCodGeograficoInput = "";
        } else {
            this.state.valorCodGeograficoInput = ((nextProps.objCodigoGeo.EsOtro == true) ? nextProps.valorCodGeografico : "");
        }
    }

    render() {
        const { objCodigoGeo, partido, valorCodGeografico, valorCodPostal } = this.props;
        const { GET_CODIGO_GEOGRAFICO } = this.props.data.cuentaDatos.accountData;
        const { existeAlMenosUnCodGeo, valorCodGeograficoInput } = this.state;
        const radioNodos = GET_CODIGO_GEOGRAFICO.filter(cg => cg.CodigoPostal == valorCodPostal).map((codigo, index) => {
            return (
                <div className="col-xs-3" key={"div-codigo-geo-" + index}>
                    <div className="container-radio radio-margin">
                        <input value={codigo.CodigoGeografico} type="radio" name="codigo-geografico" id={"codigo-geografico-" + index}
                            checked={(codigo.CodigoGeografico == valorCodGeografico)}
                            onChange={(e) => this.props.changeInput(e.target.value)} />

                        <label className="lbl-radio label-secondary" htmlFor={"codigo-geografico-" + index}>{codigo.CodigoGeografico}</label>
                    </div>
                </div>
            );
        });

        let mensajeError = null;
        //if (ValidarPantalla == true) {
        //    if (Validaciones.CodigoGeograficoSeleccionado == false) {
        //        mensajeError = <label className="error">Debe seleccionar un código geografico</label>;
        //    }
        //}

        return (
            <div>
                <div className="row">
                    <div className="col-xs-12">
                        <h5>{"Código geográfico para " + partido}</h5>
                    </div>
                </div>
                <div>
                    {radioNodos}

                    <div className="col-xs-6">
                        <div className="row">
                            <div className="col-xs-6">
                                <div className="container-radio radio-margin">
                                    <input value="" type="radio" name="codigo-geografico" id="codigo-geografico-base" checked={(this.state.existeAlMenosUnCodGeo == false)}
                                        onChange={(e) => this.props.changeInput(e.target.value, true)} />

                                    <label className="lbl-radio label-secondary" htmlFor="codigo-geografico-base">Otro</label>
                                </div>
                            </div>
                            <div className="col-xs-6">
                                <input value={this.state.valorCodGeograficoInput} type="text"
                                    className="form-control default-input" maxLength="5" disabled={(this.state.existeAlMenosUnCodGeo == true)}
                                    onChange={(e) => this.props.changeInput(e.target.value, true)} />
                            </div>
                        </div>
                    </div>
                    <div className="col-xs-12">
                        {mensajeError}
                    </div>
                </div>
            </div>
        );
    }
}

export default CodigoGeografico;